import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { StyledContainer, StyledDesc } from './SectionChart.styled';
import { SectionChartProps } from './SectionChart.types';

const SectionChart: React.FC<SectionChartProps> = ({
  title,
  children,
  desc,
  descExtra
}) => {
  return (
    <StyledContainer>
      <Heading2 as="h3">{title}</Heading2>
      {desc && (
        <StyledDesc className="isTop">
          <HtmlTrans ns="developer-career-report-2023" i18nKey={desc} />
        </StyledDesc>
      )}

      {children}
      {descExtra && (
        <StyledDesc>
          <HtmlTrans ns="developer-career-report-2023" i18nKey={descExtra} />
        </StyledDesc>
      )}
    </StyledContainer>
  );
};

export default SectionChart;
